export default __webpack_public_path__ + "dd2c880cbbb4ec0d970f64d43a2cf052.jpg";